import { DealsDepartments } from '@/models/GoldVision/GoldVisionDeal';

import { createAction, createAsyncAction } from 'typesafe-actions';

import { GetDealsDataResponse } from '../types';

export type GetGoldVisionDealsRequestPayload = {
  page_number: number;
  lines_per_page: number;
  proposal_id?: number;
  company_ids?: string[] | number[];
  owners?: string[];
  statuses?: string[];
  departments?: number[];
  summary?: string;
  created_from?: string;
  created_to?: string;
};

export type GetDealsDepartmentsResponse = {
  success: boolean;
  data: DealsDepartments[];
};

export type GetGoldVisionDealsSuccessPayload = {
  data: GetDealsDataResponse;
};

export type GoldVisionResyncStatusResponse = {
  success: boolean;
  data: { in_progress: boolean };
};

export type UpdateDepartmentsPayload = {
  gold_vision_id: number;
};

export type DonloadExecutionSummaryPayload = {
  transaction_id_list: number[];
};

export const getGoldVisionOpenDeals = createAsyncAction(
  'deals/getGoldVisionOpenDeals/request',
  'deals/getGoldVisionOpenDeals/success',
  'deals/getGoldVisionOpenDeals/failure',
)<
  GetGoldVisionDealsRequestPayload,
  GetGoldVisionDealsSuccessPayload,
  undefined
>();

export const getGoldVisionClosedDeals = createAsyncAction(
  'deals/getGoldVisionClosedDeals/request',
  'deals/getGoldVisionClosedDeals/success',
  'deals/getGoldVisionClosedDeals/failure',
)<
  GetGoldVisionDealsRequestPayload,
  GetGoldVisionDealsSuccessPayload,
  undefined
>();

export const getDealsDepartments = createAsyncAction(
  'deals/getDealsDepartments/request',
  'deals/getDealsDepartments/success',
  'deals/getDealsDepartments/failure',
)<undefined, GetDealsDepartmentsResponse, undefined>();

// Tracks whether a Gold Vision resync is running, driving the refresh button feedback.
export const setGoldVisionResyncInProgress = createAction(
  'deals/setGoldVisionResyncInProgress',
)<boolean>();

export const getUpdateDepartments = createAsyncAction(
  'deals/getUpdateDepartments/request',
  'deals/getUpdateDepartments/success',
  'deals/getUpdateDepartments/failure',
)<UpdateDepartmentsPayload, undefined, undefined>();

export const downloadExecutionSummaryReport = createAsyncAction(
  'deals/downloadExecutionSummary/request',
  'deals/downloadExecutionSummary/success',
  'deals/downloadExecutionSummary/failure',
)<DonloadExecutionSummaryPayload, undefined, undefined>();
